module.exports = __webpack_public_path__ + "static/media/logo-white.049006ec.png";